import React, { Component } from "react"
import { translate } from "react-i18next"

class LanguageSwitcher extends Component {
  constructor(props) {
    super(props)
    this.handleChangeLanguage = this.handleChangeLanguage.bind(this)
  }

  handleChangeLanguage(lng) {
    const { i18n } = this.props
    i18n.changeLanguage(lng)
  }

  renderLanguageChoice({ code, label }) {
    return (
        //<li key={code} className={buttonClass}>
        <li key={code} className={this.props.i18n.language === code ? ("ais-Pagination-item ais-Pagination-item--selected ais-Pagination-item--page") : ("ais-Pagination-item ais-Pagination-item--page")}>
            <a
                key={code}
                className={this.props.i18n.language === code ? ("ais-Pagination-link ais-Pagination-link--selected") : ("ais-Pagination-link")}
                onClick={() => this.handleChangeLanguage(code)}
            >
                {label}
            </a>
        </li>
    )
  }
				

  render() {
    const languages = [
        { code: "de", label: "DE" },
        { code: "en", label: "EN" },
        { code: "fr", label: "FR" },
        { code: "es", label: "ES" },
        { code: "ru", label: "RU" },
    ]
    return (
      <div className="LanguageSwitcher">
            <ul className="ais-Pagination-list">
                {languages.map(language => this.renderLanguageChoice(language))}
            </ul>
      </div>
    )
  }
}
export default translate("Index")(LanguageSwitcher)